import React from 'react'

import image from '../assets/back.png'

// scroll effect for the buttton
import { Link } from 'react-scroll'

// icons
import { BsArrowUpRight } from 'react-icons/bs'

// motion
import { motion } from 'framer-motion'

// Variant
import { fadeIn } from '../variants'

// services data
const services = [
  {
    id: 1,
    name: 'Responsive Design',
    description:
      'With the increasing number of users accessing websites from mobile devices, a front-end developer can ensure that a website is optimized for different screen sizes and devices, using responsive design techniques.',
  },
  {
    id: 2,
    name: 'Version Control',
    description:
      'I am skilled in version control systems such as Git and have experience in collaborating with other developers using agile development methodologies.',
  },
  {
    id: 3,
    name: 'Website Optimization',
    description:
      'I am skilled in optimizing websits performance, load speed, and search engine visibility.',
  },
  {
    id: 4,
    name: 'Cross-Browser Compatibility',
    description:
      'I ensure that a website works properly on different browsers and platforms..',
  },
  {
    id: 5,
    name: 'Debugging and Testing',
    description:
      'I identify and fix bugs in a websites code and test it to ensure that it works as expected.',
  },
  {
    id: 6,
    name: 'Collaboration with Back-end Developers',
    description:
      'I work with back-end developers to integrate the websites front-end with the back-end functionality.',
  },
]

const Services = () => {
  return (
    <div id="services" className="mt-[450px] lg:mt-[150px] section">
      <div className="container mx-auto lg:mt-[200px]">
        <div className="flex flex-col lg:flex-row">
          {/* text */}
          <div className="flex-1 lg:w-1/2 relative mb-12 lg:mb-0">
            <img
              src={image}
              alt="image of a mac"
              className="hidden lg:flex absolute top-[20rem] z-[0] rounded-full mix-blend-lighten"
            />
            <div>
              <div className=" h2  lg:mt-0 text-accent mb-6 font-extrabold">
                What i do
              </div>
              <div className="h3 max-w-[455px] mb-16">
                I create user interfaces and user experiences of a website or
                application, making it visually appealing and easy to use.
              </div>

              {/* button link */}
              <Link activeClass="active" smooth={true} spy={true} to="work">
                <button className="btn btn-sm z-[50px] cursor-pointer relative">
                  My Projects
                </button>
              </Link>
            </div>
          </div>

          {/* services */}
          <div className="lg:flex-2 lg:w-1/2"
          >
            {/* services list */}
            <div>
              {services.map((data, index) => {
                return (
                  <div
                    className=" border-b border-white/20 mb-5 md:max-w-[500px] lg:max-w-[550px] flex"
                    key={index}
                  >
                    <div className=" md:mx-auto md:max-w-[500px] lg:max-w-[550px]">
                      <div className="font-extrabold text-[20px]">
                        {data.name}
                      </div>
                      <p className="">{data.description}</p>
                    </div>
                    <div className="mb-1">
                      <div className="flex  flex-col flex-1 items-end">
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Services
